// Module
var code = "<div style=display:inline;word-wrap:break-word;white-space:pre-line translate=\"{{ ::bundle }}\" translate-values=arguments></div>";
// Exports
module.exports = code;